// Import uuid generator
import { v4 as uuidv4 } from 'uuid';

// Function to generate an unique file name from a givent file name
export function generateUniqueFileName(fileName) {
    // If the fileName is no a string
    if (typeof fileName !== 'string')
        throw new Error('File name is not a valid string');

    // Get the last index of dot in the file name (locate extension)
    const lastDotIndex = fileName.lastIndexOf('.');

    // If the file doesn't have extension
    if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1)
        throw new Error('File name must include a valid extension');

    // Generate the memeber of our unique filename
    const baseName = fileName.substring(0, lastDotIndex);
    const extension = fileName.substring(lastDotIndex + 1).toLowerCase();
    const uuid = uuidv4();

    // Return the generated file name
    return `${baseName}-${uuid}.${extension}`;
}
